import {Component, OnDestroy, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {NavigationEnd, Router} from "@angular/router";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
    title: string;
    subscription: Subscription;

    constructor(private location: Location,
                private router: Router) {
    }

    ngOnInit() {
        this.setTitle();
        this.subscription = this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                this.setTitle();
            }
        })
    }

    setTitle() {
        let page = this.location.path();
        if (page === '') {
            this.title = "Online tananyag munkavédelmi képviselőknek"
        }
        if (page === '/modul-1') {
            this.title = "1. Modul"
        }
        if (page === '/modul-2') {
            this.title = "2. Modul"
        }
        if (page === '/modul-3') {
            this.title = "3. Modul"
        }
        if (page === '/modul-4') {
            this.title = "4. Modul"
        }
        if (page === '/modul-5') {
            this.title = "5. Modul"
        }
        if (page === '/modul-6') {
            this.title = "6. Modul"
        }
        if (page === '/modul-7') {
            this.title = "7. Modul"
        }
        if (page === '/modul-8') {
            this.title = "8. Modul"
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
